<script>
  export let isMuted;
</script>

{#if isMuted}
    <i class="fa-thin fa-video-slash red"></i>
{:else}
    <i class="fa-thin fa-video"></i>
{/if}

<style lang="scss">

  .red {
    color: red;
  }

</style>
